export default __webpack_public_path__ + "img/pin_icons/commercial_b.svg";